"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipBackgroundView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const colors_1 = require("../../common/colors");
const VStack_1 = __importDefault(require("../ui-components/VStack"));
const native_base_1 = require("native-base");
const AppBackgroundView = ({ style, children, ...restProps }) => {
    const appColor = (0, colors_1.useColorTheme)();
    return ((0, jsx_runtime_1.jsxs)(native_base_1.Stack, { style: [{ width: "100%", height: "100%" }, style], ...restProps, children: [(0, jsx_runtime_1.jsx)(react_native_1.StatusBar, { translucent: true, barStyle: "light-content", backgroundColor: colors_1.Colors.BLACK_PRIMARY }), (0, jsx_runtime_1.jsx)(VStack_1.default, { flex: 1, bg: appColor.APP_BG, height: "100%", children: children })] }));
};
// export const GradientBackgroundView = ({
//   children,
// }: AppBackgroundViewProps): JSX.Element => {
//   return (
//     <ImageBackground
//       source={require("../../assets/images/bg_image.png")}
//       style={{ width: "100%", height: "100%" }}
//     >
//       {children}
//     </ImageBackground>
//   );
// };
const MembershipBackgroundView = ({ children, }) => {
    return ((0, jsx_runtime_1.jsx)(VStack_1.default, { flex: 1, bg: `${colors_1.Colors.DARK_700}`, width: "100%", children: (0, jsx_runtime_1.jsx)(react_native_1.ImageBackground, { source: { uri: "https://plus.unsplash.com/premium_vector-1721488302201-2d1450e85f20?q=80&w=3560&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" }, style: { width: "100%", height: "100%" }, resizeMode: "contain", children: children }) }));
};
exports.MembershipBackgroundView = MembershipBackgroundView;
exports.default = AppBackgroundView;
